import {svgIconWrapper} from '../svg-icon-wrapper';

import DialpadRegular from './dialpad-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <DialpadRegular {...props} />;
}

SvgComponent.iconName = 'dialpadRegular';

export const DialpadRegularIcon = svgIconWrapper(SvgComponent);
